import HundredBricksAPIError from '../HundredBricksAPIError';
class SendUnusualAccessError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SendUnusualAccessError', ...args);
    }
}
export default SendUnusualAccessError;
